import { defineComponent as _defineComponent } from 'vue'
import { CardData, CardType } from '~/composables/useCardData';


export default /*#__PURE__*/_defineComponent({
  __name: 'CardLink',
  props: {
    item: null,
    type: null,
    showExcerpt: { type: Boolean },
    clampTitle: { type: Boolean }
  },
  setup(__props: any) {



return { __sfc: true, }
}

})